module.exports = __webpack_public_path__ + "img/vmware-pulse-iot-center.d800fbb2.webp";